import { IMeeting, IMeetingCategory, IMeetingData, IMeetingProtocol, IMeetingsParams, IShortItem, ITableRes } from 'types'

import { baseApi } from './baseApi'

export const meetingsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_meetings: builder.query<ITableRes<IMeeting>, IMeetingsParams>({
      query: (params) => ({
        url: '/meetings/',
        params,
      }),
      providesTags: ['meetings'],
    }),
    GET_meetingById: builder.query<IMeeting, string>({
      query: (id) => {
        return {
          url: `/meetings/${id}/`,
        }
      },
      providesTags: ['meeting'],
    }),
    POST_meeting: builder.mutation<IMeeting, IMeetingData>({
      query: (body) => ({
        url: `/meetings/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['meetings'],
    }),
    PUT_meeting: builder.mutation<IMeeting, { id: string; body: IMeetingData }>({
      query: ({ id, body }) => ({
        url: `/meetings/${id}/`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['meetings', 'meeting'],
    }),
    PATCH_meetingStatus: builder.mutation<IMeeting, { id: string; body: {status: string} }>({
      query: ({ id, body }) => ({
        url: `/meetings/${id}/update-status/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['meetings', 'meeting'],
    }),
    DELETE_meeting: builder.mutation<IMeeting, string>({
      query: (id) => ({
        url: `/meetings/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['meetings'],
    }),
    GET_meetingCategories: builder.query<ITableRes<IMeetingCategory>, void>({
      query: () => ({
        url: '/meeting-categories/',
      }),
      transformResponse: (response: ITableRes<IShortItem>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['meeting-categories'],
    }),
    GET_meetingProtocolById: builder.query<IMeetingProtocol, string>({
      query: (id) => {
        return {
          url: `/meetings/${id}/protocol/`,
        }
      },
      providesTags: ['meeting-protocol'],
    }),
    POST_meetingProtocol: builder.mutation<IMeetingProtocol, { id: string; body: IMeetingProtocol }>({
      query: ({ id, body }) => ({
        url: `/meetings/${id}/protocol/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['meeting-protocol'],
    }),
  }),
})

export const {
  useGET_meetingsQuery,
  useGET_meetingByIdQuery,
  usePOST_meetingMutation,
  usePUT_meetingMutation,
  useDELETE_meetingMutation,
  useGET_meetingCategoriesQuery,
  useGET_meetingProtocolByIdQuery,
  usePOST_meetingProtocolMutation,
  usePATCH_meetingStatusMutation
} = meetingsAPI
